<div id="entry-info-dialog" class="kl-entry-info">
  <section class="kl-entry-info__block">
    <h3 class="kl-entry-info__heading">{{ 'added' | translate }}</h3>
    <dl class="kl-entry-info__dl">
      <dt>{{ 'created_user' | translate }}</dt>
      <dd>{{ userName(audit()?.['created_user']) }}</dd>
      <dt>{{ 'added_date' | translate }}</dt>
      <dd>{{ dateTime(audit()?.['created_date']) }}</dd>
    </dl>
  </section>

  <hr class="kl-entry-info__hr" />

  <section class="kl-entry-info__block">
    <h3 class="kl-entry-info__heading">{{ 'last_changed' | translate }}</h3>
    <dl class="kl-entry-info__dl">
      <dt>{{ 'modified_user' | translate }}</dt>
      <dd>{{ userName(audit()?.['modified_user']) }}</dd>
      <dt>{{ 'last_modified_date' | translate }}</dt>
      <dd>{{ dateTime(audit()?.['modified_date']) }}</dd>
    </dl>
  </section>
</div>
